import { Theme } from '@mui/material';

const Alert = (theme: Theme) => {
  return {
    MuiAlert: {
      variants: [
        {
          props: { severity: 'success' },
          style: {
            backgroundColor: '#f0fdf4',
            color: '#166434',
            border: '1px solid #d5fae2',
            borderRadius: '12px',
            '& .MuiAlert-message': {
              width: '100%',
            },
          },
        },
      ],
    },
  };
};

export default Alert;
